const styles = (theme) => ({
    logActionIcon: {
        marginRight: 4,
    },
});

export default styles;
